import request from 'assets/js/http';
// 获取OKTA跳转链接
export function login() {
  return request({
    url: '/common/okta/login',
    method: 'post',
    data: { source: 1 }
  });
}
export function larkLogin(data) {
  return request({
    url: '/common/lark/login',
    method: 'post',
    data
  });
}
// 退出登录
export function logout() {
  return request({
    url: '/common/logout',
    method: 'post',
    data: {}
  });
}
export function getTokenByKey(tokenKey) {
  return request({
    url: '/common/getTokenByKey',
    method: 'post',
    data: { tokenKey }
  });
}
// 用户信息-获取
export function getInfo() {
  return request({
    url: '/account/loginUser',
    method: 'post',
    data: {}
  });
}
